export const Config = {
   
    //  API_URL_LOCAL: 'http://localhost:8000/api/',
    // API_URL_IMAGE: 'http://localhost:8000',

   API_URL_LOCAL: 'https://cccbackend.conquercropcare.com/api/',
   API_URL_IMAGE: 'https://cccbackend.conquercropcare.com',
  }
  